import { Component, OnInit } from '@angular/core';
import { PartnerService } from '../services/partner.service';
import{UserServices} from '../services/userservices.service'
import { ApplicationService } from '../services/application.service'
@Component({
  selector: 'app-laboratory',
  templateUrl: './laboratory.component.html',
  styleUrls: ['./laboratory.component.css']
})
export class LaboratoryComponent implements OnInit {

  orderItemList:any[];
  isLoginByAdmin: boolean = false;
  partnerTypeId:string=''
  //orderItemList : Observable<any>;
 statusMessage: string = "Loading data please wait...";
 constructor(private _partnerService:PartnerService,private userServices:UserServices,private _applicationService: ApplicationService ) { 
  this.isLoginByAdmin = _applicationService.loginUserDetails.isAdmin
  this.partnerTypeId = _applicationService.loginUserDetails.partnertypeId
 }

 ngOnInit() {
   this.getLaborartoryOrder();
 }

 getLaborartoryOrder() {   
   this._partnerService.getLaboratoryOrder()
     .subscribe(
       (employeeData) => {
         if (employeeData == null) {
           this.statusMessage = "Employee Id does not exist..";
         }
         else {
           this.orderItemList = employeeData.response.order;           
         }         
       console.log(this.orderItemList)
       },
       (error) => {
         this.statusMessage = "Problem with the service. Please try again after sometime";
         console.log(error);
       }

     );
 }
 viewItems(data) {
   debugger
   if (data.isViewRecord) {
       data.isViewRecord = false;
   }
   else {
       data.isViewRecord = true;
   }

  
}

  userVerfication(userDetails) {
    this.userServices.setPatientData(userDetails)
  }

}
